module.exports = __webpack_public_path__ + "static/media/discover.54a2e153.png";